import { Directive } from '@angular/core';

@Directive({
    selector: '[ngxAurTableSearchPrefix]',
    standalone: false
})
export class NgxAurTableSearchPrefixDirective {

  constructor() { }

}
